import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';
import {pageOneSchema} from './utilities/validationSchema';
import {useNavigate, useParams} from 'react-router-dom';
import InfoFormComponent from 'components/forms/info';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import DotsLoading from 'components/loadings/dotsLoading';
import useSetInitialProvince from 'utilities/hooks/initialProvince';
import {useFarm} from 'context/farmContext';

const EditInfoForm = () => {
  const {guid} = useParams();
  const navigate = useNavigate();
  const {provinces} = UseGetProvince();
  const {state, city} = useSetInitialProvince(provinces);
  const {updateTitlePage} = useFarm();

  const {productDetail, isLoading} = useGetPostDetail(guid || '');

  return (
    <>
      <Header title=" ثبت آگهی" />
      <div className="px-3 mt-6 mb-8 pb-12">
        {isLoading ? (
          <DotsLoading />
        ) : (
          <Formik
            initialValues={{
              title: productDetail?.title || '',
              description: productDetail?.description || '',
              hide_phone_number: productDetail?.phone_number ? true : false,
              city: String(productDetail?.city.id) || String(city?.value) || '',
              state:
                String(productDetail?.state.id) || String(state?.value) || '',
            }}
            enableReinitialize={true}
            validationSchema={pageOneSchema}
            onSubmit={values => {
              updateTitlePage(values);
              navigate(`/farm/edit/quality/${guid}`);
            }}
          >
            {({values}) => {
              return (
                <Form>
                  <InfoFormComponent
                    cities={
                      provinces?.find(x => x.id === Number(values.state))
                        ?.cities || []
                    }
                    values={values}
                    app="farm"
                  />
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
    </>
  );
};

export default EditInfoForm;
